import Head from '@/components/layout/Head';

const Datenschutz = () => {
  return (
    <>
      <Head
        title="Datenschutzerklärung - PayPal Gebührenrechner | paycal.org"
        description="Datenschutzerklärung des PayPal Gebührenrechners. Erfahren Sie mehr über die Verarbeitung Ihrer persönlichen Daten."
        canonical="https://paycal.org/datenschutz"
      />
      <div className="container mx-auto px-4 py-8">
        <article className="prose max-w-none">
          <h1>Datenschutzerklärung</h1>

          <h2>1. Datenschutz auf einen Blick</h2>
          <h3>Allgemeine Hinweise</h3>
          <p>
            Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit 
            Ihren personenbezogenen Daten passiert, wenn Sie diese Website besuchen. 
            Personenbezogene Daten sind alle Daten, mit denen Sie persönlich 
            identifiziert werden können.
          </p>

          <h2>2. Allgemeine Hinweise und Pflichtinformationen</h2>
          <h3>Datenschutz</h3>
          <p>
            Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten 
            sehr ernst. Wir behandeln Ihre personenbezogenen Daten vertraulich und 
            entsprechend der gesetzlichen Datenschutzvorschriften sowie dieser 
            Datenschutzerklärung.
          </p>

          <h2>3. Datenerfassung auf dieser Website</h2>
          <h3>Cookies</h3>
          <p>
            Unsere Website verwendet Cookies. Das sind kleine Textdateien, die Ihr 
            Webbrowser auf Ihrem Endgerät speichert. Cookies helfen uns dabei, unser 
            Angebot nutzerfreundlicher, effektiver und sicherer zu machen.
          </p>

          <h3>Google Analytics</h3>
          <p>
            Diese Website nutzt Funktionen des Webanalysedienstes Google Analytics. 
            Anbieter ist die Google Ireland Limited, Gordon House, Barrow Street, 
            Dublin 4, Irland.
          </p>

          {/* Additional sections for complete privacy policy */}
        </article>
      </div>
    </>
  );
};

export default Datenschutz;